import React from "react";
import { Link } from "react-router-dom";

import Tagline from "../../components/tagline";
import Navbar from "../../components/navbar";
import About from "../../components/about";
import Client from "../../components/client";
import Blogs from "../../components/blogs";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";

import bg2 from "../../assets/images/bg/6.jpg";
import bg3 from "../../assets/images/bg/1.jpg";
import map from "../../assets/images/map-plane.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/swiper-bundle.css";
import Card from "../../components/card";
import Services from "../../components/services";
import Stats from "../../components/Stats";
import WhyUs from "../../components/WhyUs";

export default function IndexTwo() {
  return (
    <>
      <Tagline />
      <Navbar
        navclass="defaultscroll is-sticky tagline-height"
        navlight={true}
        manuclass="justify-end nav-light"
      />
      <section
        id="home"
        className="relative h-screen overflow-hidden bg-gray-900"
      >
        <div className="absolute inset-0">
          <Swiper
            className="w-full h-full"
            loop={true}
            speed={1500}
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            effect="fade"
            modules={[Autoplay, EffectFade]}
          >
            {[bg2, bg3].map((bg, index) => (
              <SwiperSlide key={index}>
                <div
                  className="relative w-full h-screen bg-cover bg-center flex items-center justify-center"
                  style={{ backgroundImage: `url(${bg})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>

                  <div className="relative z-10 container mx-auto px-6 text-center text-white">
                    <div className="animate-fade-in-up">
                      <img
                        src={map}
                        alt="World map"
                        className="mx-auto mb-8 w-[250px] md:w-[320px] opacity-90 hover:scale-105 transition-transform duration-500"
                      />
                      <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6 drop-shadow-lg">
                        {index === 0 ? (
                          <>
                            Find the Best <br /> Universities Abroad
                          </>
                        ) : (
                          <>
                            Discover Your Next <br /> University Placement Abroad
                          </>
                        )}
                      </h1>

                      <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-300 leading-relaxed">
                        {index === 0
                          ? "Explore top international universities that align with your goals. Get expert insights on programs, rankings, and admission requirements for your dream destination."
                          : "Get personalized guidance to find the ideal international university. We simplify your application process and help you begin your academic adventure abroad with confidence."}
                      </p>

                      <div className="mt-10">
                        <Link
                          to="/apply"
                          className="inline-flex items-center justify-center gap-2 px-8 py-3 text-lg font-semibold rounded-full bg-slate-900 hover:from-red-600 hover:to-red-700 transition-all duration-500 shadow-lg hover:shadow-red-500/40"
                        >
                          Apply Now
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.8}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
        <About />

      <Stats />

      <section className="relative md:pb-24 pb-16 overflow-hidden">
      <WhyUs />
        <Card 
        />

        <Client />

        <Blogs />
      </section>
      <Footer />
      <Switcher />
    </>
  );
}
